import type { SVGProps } from 'react';

const CompressIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 28 28" fill="none" {...props}>
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M24.5 16.333V18.9c0 1.96 0 2.94-.381 3.689a3.5 3.5 0 0 1-1.53 1.53c-.749.381-1.729.381-3.689.381h-2.567m-4.666-21H9.1c-1.96 0-2.94 0-3.689.381a3.5 3.5 0 0 0-1.53 1.53C3.5 6.16 3.5 7.14 3.5 9.1v2.567M3.5 24.5l7-7m0 0h-7m7 0v7M24.5 3.5l-7 7m0 0h7m-7 0v-7"
    />
  </svg>
);

export default CompressIcon;
